import React from "react"
import { FormHelperText, Input, TextareaAutosize, Typography } from "@material-ui/core"
import { criteriaGradingRules } from "../../Constants"

const Report = ({ report, showAccessCodes }) => (

    report.accepted === true ?
        <>
            {
                criteriaGradingRules.map((c, i) => (
                    <div key={i}>
                        <Input
                            type="number"
                            fullWidth
                            name={c.name}
                            disabled
                            value={report[c.name] || ""}
                            required
                            aria-describedby={c.name + "-helper"}
                            inputProps={{
                                max: 10,
                                maxLength: 4,
                                min: 0
                            }}
                        />
                        <FormHelperText id={c.name + "-helper"}>{c.title}</FormHelperText>
                    </div>
                ))
            }
            <hr />
        </>
        :
        <>
            <TextareaAutosize
                disabled
                maxRows={10}
                name="observation"
                value={report.observation}
                required
                aria-describedby={"observation-helper"}
            />
            <FormHelperText id={"observation-helper"}>Observação: descrição da recusa</FormHelperText>

            {
                showAccessCodes && <Typography>
                    Avaliador: {report.accessCode}
                </Typography>
            }
            <hr />
        </>
)
Report.defaultProps = {
    showAccessCodes: false
}

export default Report